import { IApplicationState } from '../../types/redux';

export const getTripInfo = (state: IApplicationState) => {
  return state.newReview.meta.tripInfo;
};
